type ItemEditorNavigationGuard = {
  hasUnsavedChanges: () => boolean
  discard: () => void
}

let activeGuard: ItemEditorNavigationGuard | null = null

export function registerItemEditorNavigationGuard(guard: ItemEditorNavigationGuard | null) {
  activeGuard = guard
}

export function confirmLeaveItemEditorIfNeeded(): boolean {
  if (!activeGuard) {
    return true
  }

  if (activeGuard.hasUnsavedChanges()) {
    const confirmed = window.confirm(
      "Discard unsaved changes? Any edits you made to this item will be lost."
    )
    if (!confirmed) {
      return false
    }
  }

  activeGuard.discard()
  return true
}
